export enum AccountDetailsTabs {
  ContactDetails = 0,
  Privacy,
}

export const tabLabels = {
  [AccountDetailsTabs.ContactDetails]: "Contact Details",
  [AccountDetailsTabs.Privacy]: "Privacy",
};
